export const teamData = [
     {
          name: "Abhishek Jindal",
          age: 30,
          gender: "Male",
          designation: "Principal Investigators",
          email: "johndoe@example.com",
          degree: "PhD (E & C Engineering), Indian Institute of Technology, Delhi",
          image: "/images/People/Abhishek_Jindal/Abhishek_Jindal_t5nvi2_c_scale,w_1400.jpg",
          imagesrcset:"/images/People/Abhishek_Jindal/Abhishek_Jindal_t5nvi2_c_scale,w_200.jpg 200w,/images/People/Abhishek_Jindal/Abhishek_Jindal_t5nvi2_c_scale,w_765.jpg 765w,/images/People/Abhishek_Jindal/Abhishek_Jindal_t5nvi2_c_scale,w_1132.jpg 1132w,/images/People/Abhishek_Jindal/Abhishek_Jindal_t5nvi2_c_scale,w_1400.jpg 1400w",
     },
     {
          name: "Amit-Mankodi",
          age: 30,
          gender: "Male",
          designation: "Principal Investigators",
          email: "johndoe@example.com",
          degree: "PhD (Computer Science), DA-IICT, Gandhinagar",
          image: "/images/People/Amit-Mankodi.jpeg",
     },
     {
          name: "Anupam Rana",
          age: 30,
          gender: "Male",
          designation: "Principal Investigators",
          email: "johndoe@example.com",
          degree: "PhD (Design Management),Indus University, Ahmedabad",
          image: "/images/People/Anupam_Rana/Anupam_Rana_ek65oe_c_scale,w_1400.jpg",
          imagesrcset:"/images/People/Anupam_Rana/Anupam_Rana_ek65oe_c_scale,w_200.jpg 200w,/images/People/Anupam_Rana/Anupam_Rana_ek65oe_c_scale,w_823.jpg 823w,/images/People/Anupam_Rana/Anupam_Rana_ek65oe_c_scale,w_1212.jpg 1212w,/images/People/Anupam_Rana/Anupam_Rana_ek65oe_c_scale,w_1400.jpg 1400w"
     },
     {
          name: "Arpit Rana",
          age: 30,
          gender: "Male",
          designation: "Principal Investigators",
          email: "johndoe@example.com",
          degree: "PhD (Computer Science), University College Cork, Ireland",
          image:"/images/People/Arpit_Rana/Arpit_Rana_vekxvt_c_scale,w_1400.jpg",
          imagesrcset :"/images/People/Arpit_Rana/Arpit_Rana_vekxvt_c_scale,w_200.jpg 200w,/images/People/Arpit_Rana/Arpit_Rana_vekxvt_c_scale,w_769.jpg 769w,/images/People/Arpit_Rana/Arpit_Rana_vekxvt_c_scale,w_1141.jpg 1141w,/images/People/Arpit_Rana/Arpit_Rana_vekxvt_c_scale,w_1400.jpg 1400w",
     },
     {
          name: "Bhaskar Chaudhury",
          age: 30,
          gender: "Male",
          designation: "Principal Investigators",
          email: "johndoe@example.com",
          degree: "PhD (Computational Plasma Physics), Institute of Plasma Research, Gandhinagar",
          image: "/images/People/Bhaskar_Chaudhury/Bhaskar_Chaudhury_ekhxdn_c_scale,w_1400.jpg",
          imagesrcset:"/images/People/Bhaskar_Chaudhury/Bhaskar_Chaudhury_ekhxdn_c_scale,w_200.jpg 200w,/images/People/Bhaskar_Chaudhury/Bhaskar_Chaudhury_ekhxdn_c_scale,w_740.jpg 740w,/images/People/Bhaskar_Chaudhury/Bhaskar_Chaudhury_ekhxdn_c_scale,w_1105.jpg 1105w,/images/People/Bhaskar_Chaudhury/Bhaskar_Chaudhury_ekhxdn_c_scale,w_1400.jpg 1400w",
     },
     {
          name: "Biswajit Mishra",
          age: 30,
          gender: "Male",
          designation: "Principal Investigators",
          email: "Principal Investigators",
          degree: "PhD (E & E Engineering), University of Southampton, UK",
          image: "/images/People/Biswajit Mishra.jpeg",
     },
     {
          name: "Kalyan Sasidhar",
          age: 30,
          gender: "Male",
          designation: "Principal Investigators",
          email: "johndoe@example.com",
          degree: "PhD (Computer Science), University of North Texas-Denton, USA",
          image: "/images/People/Kalyan_Sasidhar/Kalyan_Sasidhar_cograe_c_scale,w_1400.jpg",
          imagesrcset:"/images/People/Kalyan_Sasidhar/Kalyan_Sasidhar_cograe_c_scale,w_200.jpg 200w,/images/People/Kalyan_Sasidhar/Kalyan_Sasidhar_cograe_c_scale,w_765.jpg 765w,/images/People/Kalyan_Sasidhar/Kalyan_Sasidhar_cograe_c_scale,w_1132.jpg 1132w,/images/People/Kalyan_Sasidhar/Kalyan_Sasidhar_cograe_c_scale,w_1400.jpg 1400w"
     },
     {
          name: "Manish Kumar",
          age: 30,
          gender: "Male",
          designation: "Principal Investigators",
          email: "johndoe@example.com",
          degree: "PhD (Electrical Engineering), Indian Institute of Technology, Patna",
          image: "/images/People/Manish_Kumar/Manish_Kumar_sqwwqu_c_scale,w_1400.jpg",
          imagesrcset:"/images/People/Manish_Kumar/Manish_Kumar_sqwwqu_c_scale,w_200.jpg 200w,/images/People/Manish_Kumar/Manish_Kumar_sqwwqu_c_scale,w_794.jpg 794w,/images/People/Manish_Kumar/Manish_Kumar_sqwwqu_c_scale,w_1161.jpg 1161w,/images/People/Manish_Kumar/Manish_Kumar_sqwwqu_c_scale,w_1400.jpg 1400w"
     },
     {
          name: "Pankaj Kumar",
          age: 30,
          gender: "Male",
          designation: "Principal Investigators",
          email: "johndoe@example.com",
          degree: "PhD (RF & Microwave), National Institue of Technology, Patna",
          image: "/images/People/Pankaj_Kumar/Pankaj_Kumar_r9aba2_c_scale,w_1400.jpg",
          imagesrcset:"/images/People/Pankaj_Kumar/Pankaj_Kumar_r9aba2_c_scale,w_200.jpg 200w,/images/People/Pankaj_Kumar/Pankaj_Kumar_r9aba2_c_scale,w_780.jpg 780w,/images/People/Pankaj_Kumar/Pankaj_Kumar_r9aba2_c_scale,w_1181.jpg 1181w,/images/People/Pankaj_Kumar/Pankaj_Kumar_r9aba2_c_scale,w_1400.jpg 1400w"
     },
     {
          name:"Prabhunath Sharma",
          age: 30,
          gender: "Male",
          designation: "Support Officers",
          email: "johndoe@example.com",
          degree: "Bachelors (Commerce),Gujarat University, Gujarat",
          image: "/images/People/Prabhunath Sharma.jpg",
     },
     {
          name: "Pritam Anand",
          age: 30,
          gender: "Male",
          designation: "Principal Investigators",
          email: "johndoe@example.com",
          degree: "PhD (Computer Science), South Asian University, New Delhi",
          image: "/images/People/Pritam_Anand/Pritam_Anand_czjap4_c_scale,w_1400.jpg",
          imagesrcset:"/images/People/Pritam_Anand/Pritam_Anand_czjap4_c_scale,w_200.jpg 200w,/images/People/Pritam_Anand/Pritam_Anand_czjap4_c_scale,w_758.jpg 758w,/images/People/Pritam_Anand/Pritam_Anand_czjap4_c_scale,w_1122.jpg 1122w,/images/People/Pritam_Anand/Pritam_Anand_czjap4_c_scale,w_1400.jpg 1400w"
     },
     {
          name: "Prosenjit Kundu",
          age: 30,
          gender: "Males",
          designation: "Principal Investigators",
          email: "johndoe@example.com",
          degree: "PhD (Mathematics), National Institute of Technology, Durgapur",
          image: "/images/People/Prosenjit_Kundu/Prosenjit_Kundu_so2d4b_c_scale,w_1400.jpg",
          imagesrcset:"/images/People/Prosenjit_Kundu/Prosenjit_Kundu_so2d4b_c_scale,w_200.jpg 200w,/images/People/Prosenjit_Kundu/Prosenjit_Kundu_so2d4b_c_scale,w_897.jpg 897w,/images/People/Prosenjit_Kundu/Prosenjit_Kundu_so2d4b_c_scale,w_1324.jpg 1324w,/images/People/Prosenjit_Kundu/Prosenjit_Kundu_so2d4b_c_scale,w_1400.jpg 1400w"
     },
     {
          name: "Sreeja Rajendran",
          age: 30,
          gender: "Male",
          designation: "Principal Investigators",
          email: "johndoe@example.com",
          degree: "PhD (E & E Engineering), BITS Pilani, Dubai Campus, UAE",
          image: "/images/People/Sreeja_Rajendran/Sreeja_Rajendran_att13c_c_scale,w_1400.jpg",
          imagesrcset:"/images/People/Sreeja_Rajendran/Sreeja_Rajendran_att13c_c_scale,w_200.jpg 200w,/images/People/Sreeja_Rajendran/Sreeja_Rajendran_att13c_c_scale,w_769.jpg 769w,/images/People/Sreeja_Rajendran/Sreeja_Rajendran_att13c_c_scale,w_1142.jpg 1142w,/images/People/Sreeja_Rajendran/Sreeja_Rajendran_att13c_c_scale,w_1400.jpg 1400w"
     },
     {
          name: "Sujay Kadam",
          age: 30,
          gender: "Male",
          designation: "Principal Investigators",
          email: "johndoe@example.com",
          degree: "PhD(Electrical Engineering),IIT Gandhinagar, India",
          image: "/images/People/Sujay_Kadam/Sujay_Kadam_2_kjmwhw_c_scale,w_1400.jpg",
          imagesrcset:"Sujay_Kadam_2_kjmwhw_c_scale,w_200.jpg 200w,/images/People/Sujay_Kadam/Sujay_Kadam_2_kjmwhw_c_scale,w_765.jpg 765w,/images/People/Sujay_Kadam/Sujay_Kadam_2_kjmwhw_c_scale,w_1139.jpg 1139w,/images/People/Sujay_Kadam/Sujay_Kadam_2_kjmwhw_c_scale,w_1400.jpg 1400w"
     },
     {
          name: "Tapas Maiti",
          age: 30,
          gender: "Female",
          designation: "Principal Investigators",
          email: "johndoe@example.com",
          degree: "PhD (E & T Engineering), Jadavpur University, Kolkata, India",
          image: "/images/People/Tapas_Maiti/Tapas_Maiti_yocnrw_c_scale,w_1400.jpg",
          imagesrcset:"/images/People/Tapas_Maiti/Tapas_Maiti_yocnrw_c_scale,w_200.jpg 200w,/images/People/Tapas_Maiti/Tapas_Maiti_yocnrw_c_scale,w_746.jpg 746w,/images/People/Tapas_Maiti/Tapas_Maiti_yocnrw_c_scale,w_1110.jpg 1110w,/images/People/Tapas_Maiti/Tapas_Maiti_yocnrw_c_scale,w_1400.jpg 1400w",
     },
     {
          name: "Tathagata bandyopadhyay",
          age: 30,
          gender: "Male",
          designation: "Principal Investigators",
          email: "johndoe@example.com",
          degree: "PhD (Statistics), University of Calcutta, India",
          image: "/images/People/Tathagata_bandyopadhyay/Tathagata_bandyopadhyay_o9dzmb_c_scale,w_1400.jpg",
          imagesrcset : "/images/People/Tathagata_bandyopadhyay/Tathagata_bandyopadhyay_o9dzmb_c_scale,w_200.jpg 200w,/images/People/Tathagata_bandyopadhyay/Tathagata_bandyopadhyay_o9dzmb_c_scale,w_765.jpg 765w,/images/People/Tathagata_bandyopadhyay/Tathagata_bandyopadhyay_o9dzmb_c_scale,w_1140.jpg 1140w,/images/People/Tathagata_bandyopadhyay/Tathagata_bandyopadhyay_o9dzmb_c_scale,w_1400.jpg 1400w"
     },
     {
          name:"Umang Patel",
          age: 30,
          gender: "Male",
          designation: "Support Officers",
          email: "johndoe@example.com",
          degree: "PhD (Physics), Sardar Patel University, Gujarat",
          image: "/images/People/Umang Patel.jpeg",
     },
     {
          name: "Yash Agrawal",
          age: 30,
          gender: "Male",
          designation: "Principal Investigators",
          email: "johndoe@example.com",
          degree: "PhD (E & C Engineering), National Institute of Technology, Hamirpur",
          image: "/images/People/Yash_Agrawal/Yash_Agrawal_sa5ofd_c_scale,w_1400.jpg",
          imagesrcset:"/images/People/Yash_Agrawal/Yash_Agrawal_sa5ofd_c_scale,w_200.jpg 200w,/images/People/Yash_Agrawal/Yash_Agrawal_sa5ofd_c_scale,w_800.jpg 800w,/images/People/Yash_Agrawal/Yash_Agrawal_sa5ofd_c_scale,w_1145.jpg 1145w,/images/People/Yash_Agrawal/Yash_Agrawal_sa5ofd_c_scale,w_1400.jpg 1400w"
     },
     {
          name: "Yash Vasavada",
          age: 30,
          gender: "Male",
          designation: "Principal Investigators",
          email: "johndoe@example.com",
          degree: "PhD (Electrical Engineering), Virginia Polytechnic Institute, USA",
          image: "/images/People/Yash_Vasavada/Yash_Vasavada_ha0hb5_c_scale,w_1400.jpg",
          imagesrcset:"/images/People/Yash_Vasavada/Yash_Vasavada_ha0hb5_c_scale,w_200.jpg 200w,/images/People/Yash_Vasavada/Yash_Vasavada_ha0hb5_c_scale,w_889.jpg 889w,/images/People/Yash_Vasavada/Yash_Vasavada_ha0hb5_c_scale,w_1294.jpg 1294w,/images/People/Yash_Vasavada/Yash_Vasavada_ha0hb5_c_scale,w_1400.jpg 1400w"
     },
     {
          name: "Rahul Mishra",
          age: 30,
          gender: "Male",
          designation: "Collaborators",
          email: "johndoe@example.com",
          degree: "Assistant Professor, Indian Institute of Technology Patana, India",
          image: "/images/Collebrators/Rahul Mishra.jpeg",
     },
     {
          name: "Dhara Shah",
          age: 30,
          gender: "Female",
          designation: "Research Staff/Students",
          email: "johndoe@example.com",
          degree: "M.Tech. (Machine Learning), DA-IICT, Gandhinagar, India",
          image: "/images/Research Staff/Dhara Shah.jpeg",
     },
     {
          name: "Kalp Pandya",
          age: 30,
          gender: "Male",
          designation: "Research Staff/Students",
          email: "johndoe@example.com",
          degree: "B.Tech. (ICT), DA-IICT, Gandhinagar, India",
          image: "/images/Research Staff/Kalp Pandya.jpeg",
     },
     {
          name: "Ritwik Agrawal",
          age: 30,
          gender: "Male",
          designation: "Research Staff/Students",
          email: "johndoe@example.com",
          degree: "M.Tech. (ICT) Pursuing, DA-IICT, Gandhinagar, India",
          image: "/images/Research Staff/Ritwik.jpeg",
     },
     {
          name: "Dhruv Panchal",
          age: 30,
          gender: "Male",
          designation: "Research Staff/Students",
          email: "johndoe@example.com",
          degree: "M.Tech. (ICT) Pursuing, DA-IICT, Gandhinagar, India",
          image: "/images/Research Staff/Dhruv Panchal.jpg",
     },
     {
          name: "Ashish Kar",
          age: 30,
          gender: "Male",
          designation: "Research Staff/Students",
          email: "johndoe@example.com",
          degree: "M.Sc. (Data Science) Pursuing, DA-IICT, Gandhinagar, India",
          image: "/images/Research Staff/Ashish Kar.jpg",
     },
     {
          name: "Yashraj Sinh",
          age: 30,
          gender: "Male",
          designation: "Research Staff/Students",
          email: "johndoe@example.com",
          degree: "M.Sc. (Data Science) Pursuing, DA-IICT, Gandhinagar, India",
          image: "/images/Research Staff/Yashraj.jpg",
     },
     {
          name: "Deepanshi Acharya",
          age: 30,
          gender: "Male",
          designation: "Research Staff/Students",
          email: "johndoe@example.com",
          degree: "M.Sc. (Data Science) Pursuing, DA-IICT, Gandhinagar, India",
          image: "/images/Research Staff/Deepanshi.jpg",
     },
     {
          name: "Kshiti Mulani",
          age: 30,
          gender: "Male",
          designation: "Research Staff/Students",
          email: "johndoe@example.com",
          degree: "M.Sc. (Data Science) Pursuing, DA-IICT, Gandhinagar, India",
          image: "/images/Research Staff/Kshiti.jpg",
     },
     {
          name: "Kirtan Soni",
          age: 30,
          gender: "Male",
          designation: "Research Staff/Students",
          email: "johndoe@example.com",
          degree: "B.Tech. (ICT) Pursuing, DA-IICT, Gandhinagar, India",
          image: "/images/Research Staff/Kirtan Soni.jpeg",
     },
     {
          name: "Krish Rupapara",
          age: 30,
          gender: "Male",
          designation: "Research Staff/Students",
          email: "johndoe@example.com",
          degree: "B.Tech. (ICT) Pursuing, DA-IICT, Gandhinagar, India",
          image: "https://png.pngtree.com/element_our/png/20181206/users-vector-icon-png_260862.jpg",
     },
     {
          name: "Sumukh Patel",
          age: 30,
          gender: "Male",
          designation: "Research Staff/Students",
          email: "johndoe@example.com",
          degree: "B.Tech. (ICT) Pursuing, DA-IICT, Gandhinagar, India",
          image: "/images/Research Staff/Sumukh.jpeg",
     },
     {
          name: "David Rajeshkumar Tandel ",
          age: 30,
          gender: "Male",
          designation: "Research Staff/Students",
          email: "johndoe@example.com",
          degree: "B.Tech. (ICT) Pursuing, DA-IICT, Gandhinagar, India",
          image: "/images/Research Staff/David.jpeg",
     },
     {
          name: "Jenish Hetalkumar Patel",
          age: 30,
          gender: "Male",
          designation: "Research Staff/Students",
          email: "johndoe@example.com",
          degree: "B.Tech. (ICT) Pursuing, DA-IICT, Gandhinagar, India",
          image: "/images/Research Staff/Jenish.jpeg",
     },
     {
          name: "Khethavath Phool Singh",
          age: 30,
          gender: "Male",
          designation: "Research Staff/Students",
          email: "johndoe@example.com",
          degree: "B.Tech. (ICT) Pursuing, DA-IICT, Gandhinagar, India",
          image: "images/Research Staff/Khethavath Phool Singh.jpeg",
     },    {
          name: "Patel Hardikkumar",
          age: 30,
          gender: "Male",
          designation: "Research Staff/Students",
          email: "johndoe@example.com",
          degree: "B.Tech. (MnC) Pursuing, DA-IICT, Gandhinagar, India",
          image: "images/Research Staff/Hardik kumar.jpeg",
     },
     {
          name: "Patel Manan Girishbhai",
          age: 30,
          gender: "Male",
          designation: "Research Staff/Students",
          email: "johndoe@example.com",
          degree: "B.Tech. (MnC) Pursuing, DA-IICT, Gandhinagar, India",
          image: "/images/Research Staff/Manan.jpeg",
     },
     {
          name: "Rushi Manubhai Chaudhary",
          age: 30,
          gender: "Male",
          designation: "Research Staff/Students",
          email: "johndoe@example.com",
          degree: "B.Tech. (ICT) Pursuing, DA-IICT, Gandhinagar, India",
          image: "/images/Research Staff/Rushi.jpeg",
     },
     {
          name: "Riya Dave",
          age: 30,
          gender: "Male",
          designation: "Research Staff/Students",
          email: "johndoe@example.com",
          degree: "M.Sc. (Data Science) Pursuing, DA-IICT, Gandhinagar, India",
          image: "https://png.pngtree.com/element_our/png/20181206/users-vector-icon-png_260862.jpg",
     },
     {
          name: "Simran Dalvi",
          age: 30,
          gender: "Male",
          designation: "Research Staff/Students",
          email: "johndoe@example.com",
          degree: "M.Sc. (Data Science) Pursuing, DA-IICT, Gandhinagar, India",
          image: "https://png.pngtree.com/element_our/png/20181206/users-vector-icon-png_260862.jpg",
     },
     {
          name: "Vishwas Shukla",
          age: 30,
          gender: "Male",
          designation: "Research Staff/Students",
          email: "johndoe@example.com",
          degree: "M.Sc. (AI/ML) Pursuing, GTU, Gujarat",
          image: "/images/Research Staff/Vishwas Shukla.jpeg",
     },
     {
          name: "Prince Patil",
          age: 30,
          gender: "Male",
          designation: "Research Staff/Students",
          email: "johndoe@example.com",
          degree: "B.Tech. (ICT) Pursuing, DA-IICT, Gandhinagar, India",
          image: "/images/Research Staff/Prince Patil.jpeg",
     },
     {
          name: "Hardik Makwana",
          age: 30,
          gender: "Male",
          designation: "Research Staff/Students",
          email: "johndoe@example.com",
          degree: "B.Tech. (ICT) Pursuing, DA-IICT, Gandhinagar, India",
          image: "/images/Research Staff/Hardik Makwana.jpeg",
     },
     {
          name: "Rishit Vaghela",
          age: 30,
          gender: "Male",
          designation: "Research Staff/Students",
          email: "johndoe@example.com",
          degree: "B.Tech. (MnC) Pursuing, DA-IICT, Gandhinagar, India",
          image: "/images/Research Staff/Rishit Vaghela.jpeg",
     },

];